import TicketNotification from './TicketNotification';
export default class CustomerRepliedNotification extends TicketNotification {
  icon() {
    return 'fas fa-reply';
  }
  content() {
    const guestName = this.guestName();
    return guestName ? this.trans('guest_replied_text', {
      name: guestName
    }) : this.trans('customer_replied_text');
  }
}
flarum.reg.add('soup-97-support', 'forum/components/notifications/CustomerRepliedNotification', CustomerRepliedNotification);